export default __webpack_public_path__ + "static/media/waze-only-icon.20e634dd.PNG";